// views/Dashboard/PainelExecutivo/areas/VisaoGeral.tsx
import React, { useMemo } from 'react';
import type { FiltrosDashboard } from '../types';
import { periodoAnteriorEquivalente } from '../../../../src/lib/dashboard/periodoAnterior';
import { rotuloPeriodoDashboard } from '../../../../src/lib/dashboard/periodoDashboard';
import { BlocoFinanceiro, BlocoComercial, BlocoGeradoras, BlocoMarketing } from './visaoGeral/blocos';

/**
 * A porta de entrada do painel: o retrato do período em quatro blocos, um por
 * área, cada um levando para a aba correspondente.
 *
 * Cada bloco carrega os PRÓPRIOS dados e aparece assim que fica pronto — o
 * Marketing não espera a base financeira, que é a mais pesada da casa. É o
 * oposto da tela corrida antiga, em que tudo carregava junto e nada aparecia
 * antes de o último terminar.
 *
 * A variação vem do período anterior de mesmo tamanho (ver
 * `periodoAnteriorEquivalente`), e some quando não existe base de comparação.
 */
const VisaoGeral: React.FC<{ filtros: FiltrosDashboard }> = ({ filtros }) => {
  const hoje = useMemo(() => new Date(), []);
  const anterior = useMemo(() => periodoAnteriorEquivalente(filtros.periodo, hoje), [filtros.periodo, hoje]);
  const rotuloAnterior = anterior ? rotuloPeriodoDashboard(anterior) : null;
  const props = { filtros, anterior, rotuloAnterior };

  return (
    <div className="space-y-4">
      <p className="text-xs text-gray-500 dark:text-gray-400">
        <strong className="text-gray-700 dark:text-gray-200">{rotuloPeriodoDashboard(filtros.periodo)}</strong>
        {rotuloAnterior ? <> · variação contra {rotuloAnterior}</> : <> · sem período anterior para comparar</>}
      </p>

      <BlocoFinanceiro {...props} />
      <BlocoComercial {...props} />
      <BlocoGeradoras {...props} />
      <BlocoMarketing {...props} />
    </div>
  );
};

export default VisaoGeral;
